(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var sectionId = drawer.getAttribute("data-section-id");
  var busy = false;
  var wasOpen = false;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return "\u00a3" + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("cart-drawer--open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-cart-drawer-open");
    wasOpen = true;
  }

  function closeDrawer() {
    drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer || !drawer.classList.contains("cart-drawer--open")) return;
    drawer.classList.remove("cart-drawer--open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("is-cart-drawer-open");
    wasOpen = false;
  }

  function changeLine(lineKey, quantity, sellingPlanId) {
    var body = { id: lineKey, quantity: quantity };
    if (sellingPlanId) {
      body.selling_plan = parseInt(sellingPlanId, 10);
    }
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart update failed");
      return res.json();
    });
  }

  function addVariant(variantId, quantity, sellingPlanId) {
    var body = { id: parseInt(variantId, 10), quantity: quantity || 1 };
    if (sellingPlanId) {
      body.selling_plan = parseInt(sellingPlanId, 10);
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    });
  }

  function updateCartAttributes(attributes) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart attributes update failed");
      return res.json();
    });
  }

  function refreshDrawer(keepOpen) {
    if (!sectionId) return Promise.resolve();

    var shouldKeepOpen = keepOpen !== false && (wasOpen || (drawer && drawer.classList.contains("cart-drawer--open")));

    return fetch("/?sections=" + encodeURIComponent(sectionId))
      .then(function (res) {
        if (!res.ok) throw new Error("Section render failed");
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var wrapper = document.createElement("div");
        wrapper.innerHTML = html.trim();
        var next = wrapper.querySelector("[data-cart-drawer]");
        var current = document.querySelector("[data-cart-drawer]");
        if (!next || !current) return;

        current.replaceWith(next);
        drawer = next;
        bindDrawer();

        if (shouldKeepOpen) {
          openDrawer();
        }
      });
  }

  function bindQtyControls() {
    drawer.querySelectorAll("[data-cart-drawer-item]").forEach(function (itemEl) {
      var lineKey = itemEl.getAttribute("data-line-key");
      var minusBtn = itemEl.querySelector("[data-cart-drawer-qty-minus]");
      var plusBtn = itemEl.querySelector("[data-cart-drawer-qty-plus]");
      var qtyValue = itemEl.querySelector("[data-cart-drawer-qty-value]");
      var removeBtn = itemEl.querySelector("[data-cart-drawer-remove]");
      var qty = parseInt(qtyValue && qtyValue.textContent, 10) || 1;
      var isSubscription = itemEl.getAttribute("data-subscription") === "true";

      function setBusy(state) {
        busy = state;
        if (minusBtn) minusBtn.disabled = state || isSubscription || qty <= 1;
        if (plusBtn) plusBtn.disabled = state || isSubscription;
        if (removeBtn) removeBtn.disabled = state;
      }

      function applyQty(nextQty) {
        if (busy || !lineKey) return;
        setBusy(true);
        changeLine(lineKey, nextQty)
          .then(function () {
            return updateCartAttributes({ cart_drawer_upgraded: "" });
          })
          .then(function () {
            return refreshDrawer(true);
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            setBusy(false);
          });
      }

      if (minusBtn) {
        minusBtn.addEventListener("click", function () {
          if (isSubscription || qty <= 1) return;
          applyQty(qty - 1);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener("click", function () {
          if (isSubscription) return;
          applyQty(qty + 1);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener("click", function () {
          applyQty(0);
        });
      }

      if (minusBtn) minusBtn.disabled = isSubscription || qty <= 1;
      if (plusBtn) plusBtn.disabled = isSubscription;
    });
  }

  function bindUpgrade() {
    var btn = drawer.querySelector("[data-cart-drawer-upgrade-btn]");
    if (!btn) return;

    btn.addEventListener("click", function () {
      if (busy) return;
      var mode = btn.getAttribute("data-upsell-mode") || "replace";
      var lineKey = btn.getAttribute("data-line-key");
      var variantId = btn.getAttribute("data-variant-id");
      var sellingPlan = btn.getAttribute("data-selling-plan");
      var packLabel = btn.getAttribute("data-pack-label") || "";

      if (!lineKey) return;
      if (mode === "replace" && !variantId) return;
      if (mode === "subscription" && !sellingPlan) return;

      busy = true;
      btn.disabled = true;

      var action;
      if (mode === "subscription") {
        action = changeLine(lineKey, 1, sellingPlan);
      } else {
        action = changeLine(lineKey, 0).then(function () {
          return addVariant(variantId, 1, sellingPlan || null);
        });
      }

      action
        .then(function () {
          return updateCartAttributes({ cart_drawer_upgraded: packLabel });
        })
        .then(function () {
          return refreshDrawer(true);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          busy = false;
        });
    });
  }

  function bindDrawer() {
    drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;

    sectionId = drawer.getAttribute("data-section-id") || sectionId;

    drawer.querySelectorAll("[data-cart-drawer-close]").forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    bindQtyControls();
    bindUpgrade();
  }

  document.addEventListener("click", function (event) {
    var openTrigger = event.target.closest("[data-cart-drawer-open]");
    if (!openTrigger) return;
    if (!document.querySelector("[data-cart-drawer]")) return;
    event.preventDefault();
    openDrawer();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });

  bindDrawer();

  window.HappyJoCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: function () {
      return refreshDrawer(true);
    },
    openAfterAdd: function () {
      return refreshDrawer(true).then(function () {
        openDrawer();
      });
    },
    isEnabled: function () {
      return !!document.querySelector("[data-cart-drawer]");
    },
  };
})();
